import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { PiggyBank } from "lucide-react";
import { fmtMoney } from "@/components/EventCard";
import { api } from "@/lib/api";
import { usePrefs } from "@/contexts/PrefsContext";

interface Due { currency: string; balance: string; threshold: string }

export const BalanceBanner = () => {
  const { t } = usePrefs();
  const [due, setDue] = useState<Due[]>([]);
  const { pathname } = useLocation();
  const onFinance = pathname.startsWith("/venue/finance");
  useEffect(() => { api.get("/venue/finance/reminder").then((r) => setDue(r.data)).catch(() => {}); }, [onFinance]);
  if (!due.length || onFinance) return null;
  return (
    <div data-testid="balance-banner" className="mb-5 rounded-3xl border border-amber-400/60 bg-amber-50 dark:bg-amber-500/10 p-4 flex flex-wrap items-center gap-3">
      <span className="h-10 w-10 rounded-2xl bg-amber-400/25 grid place-items-center shrink-0"><PiggyBank className="h-5 w-5 text-amber-700 dark:text-amber-300" /></span>
      <div className="flex-1 min-w-[200px] text-sm">
        <p className="font-bold">{t("b8.balanceTitle")}</p>
        <p className="text-muted-foreground">
          {t("b8.balanceBody")}{" "}
          {due.map((d, i) => <bdi key={d.currency} data-testid={`balance-banner-${d.currency}`} className="font-bold text-foreground">{i ? " · " : ""}{fmtMoney({ amount: d.balance, currency: d.currency } as any)}</bdi>)}
        </p>
      </div>
      <Link to="/venue/finance" data-testid="balance-banner-link" className="h-10 px-5 rounded-full bg-foreground text-background text-sm font-bold inline-flex items-center">{t("b8.viewStatement")}</Link>
    </div>
  );
};
